import React from 'react';
import { useNavigate } from 'react-router-dom';

//Material
import { Avatar, Box, Grid, Tooltip, Typography } from '@mui/material';

import { Stack } from '@mui/system';

// import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
// import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import { connect, useDispatch } from 'react-redux';

import DefaultAvatar from '../assets/defaultPostImg.jpg';
import { base } from '../redux/thunk';

import { setIsOpenDeleteModal } from '../redux/mainReducer';
import { ArrowBackIos } from '@mui/icons-material';
import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';
import StarIcon from '@mui/icons-material/Star';
import ApiService from '../helpers/apiHelper';

// import ApiService from '../helpers/apiHelper';

function UserListCardChatTop({
  deleteChat,
  index,
  user,
  language,
  userData,
  getUserSubscriptionsThunk,
  subscriptions,
  setSelectedChat,
  setChats
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const apiImportant = new ApiService('notification/participants/make-important');

  // const apiImportant = new ApiService('/participants/make-important');

  const importantHandler = () => {
    if (user.isImportantForUser) {
      apiImportant.updateDataQuery({ chatId: user.chatId, isChatImportant: false }).then((res) => {
        setChats();
        setSelectedChat({ ...user, isImportantForUser: false });
      });
    } else {
      apiImportant.updateDataQuery({ chatId: user.chatId, isChatImportant: true }).then((res) => {
        setChats();
        setSelectedChat({ ...user, isImportantForUser: true });
      });
    }
  };

  return (
    <Grid
      container
      sx={{
        padding: '5px',
        justifyContent: 'space-between',
        borderBottom: '2px solid #F5F4F4',
        pb: { xs: '16px', md: '24px' },
        alignItems: 'center'
      }}
    >
      <Grid item xs={8}>
        <Stack
          sx={{
            width: '100%',
            marginTop: '10px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }}
        >
          <ArrowBackIos
            onClick={() => {
              setSelectedChat(null);
              // setChats();
            }}
            sx={{
              display: { xs: 'block', sm: 'block', md: 'none' },
              alignItems: 'center',
              ml: '10px',
              mr: '10px'
            }}
          />
          <Avatar
            onClick={() => {
              navigate(`/${language}/user-page/${user?.userInfoDTO?.id}?type=posts`);
            }}
            src={user.userInfoDTO?.photoUrl ? `${user.userInfoDTO?.photoUrl}` : DefaultAvatar}
            sx={{
              width: 60,
              height: 60,
              border: '2px solid #E2F2FF',
              boxShadow: '0px 0px 15px -5px #00000026',
              cursor: 'pointer',
              mr: { xs: '5px', sm: '10px' }
            }}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
            <Typography
              variant="subtitle"
              sx={{
                fontFamily: 'FixelText-Medium !important',
                fontSize: user.userInfoDTO?.name && user.userInfoDTO?.surname ? '14px' : '18px',
                textAlign: 'left',
                cursor: 'pointer',
                color: '#7c7c7c',
                wordBreak: 'break-word'
              }}
              onClick={() => {
                navigate(`/${language}/user-page/${user.userInfoDTO.id}?type=posts`);
              }}
            >
              {`@${user.userInfoDTO?.nickname}`}
            </Typography>
            {user.userInfoDTO?.name && user.userInfoDTO?.surname && (
              <Typography
                variant="subtitle"
                sx={{
                  fontFamily: 'Public Sans,sans-serif !important',
                  fontSize: { xs: '14px', sm: '16px', md: '18px' },
                  textAlign: 'left',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  navigate(`/${language}/user-page/${user.userInfoDTO.id}?type=posts`);
                }}
              >
                {`${user.userInfoDTO?.name} ${user.userInfoDTO?.surname}`}
              </Typography>
            )}
          </Box>
        </Stack>
      </Grid>
      <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
        <Tooltip title={'Видалити чат'}>
          <DeleteOutlineOutlinedIcon
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              dispatch(
                setIsOpenDeleteModal({
                  isOpen: true,
                  text: 'цей чат?',
                  func: deleteChat,
                  id: user.chatId
                })
              );
            }}
            sx={{ mr: 1, cursor: 'pointer' }}
          />
        </Tooltip>
        {!user.isImportantForUser ? (
          <StarOutlineOutlinedIcon
            onClick={(event) => {
              event.stopPropagation();
              importantHandler();
            }}
            sx={{
              zIndex: 99,
              color: '#D6D6D6',
              ':hover': {
                color: 'rgb(239, 201, 56)'
              }
            }}
          />
        ) : (
          <StarIcon
            onClick={(event) => {
              event.stopPropagation();
              importantHandler();
            }}
            sx={{
              zIndex: 99,
              color: 'rgb(239, 201, 56)'
            }}
          />
        )}
      </Grid>
    </Grid>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    subscriptions: state.global.userSubscriptions,
    blockedUsers: state.global.blockedUsers
  };
};
export default connect(mapStateToProps, {
  getUserSubscriptionsThunk: base.getUserSubscriptionsThunk
})(UserListCardChatTop);
